import { render, staticRenderFns } from "./prod-cards.vue?vue&type=template&id=18f2108a&scoped=true"
import script from "./prod-cards.vue?vue&type=script&lang=js"
export * from "./prod-cards.vue?vue&type=script&lang=js"
import style0 from "./prod-cards.vue?vue&type=style&index=0&id=18f2108a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f2108a",
  null
  
)

export default component.exports